import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthenticationService } from './core/services/auth.service';
import { Subscription } from 'rxjs';

export let browserRefresh = false;

@Component({
  selector: 'app-ubold',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  subscription: Subscription;
  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    private authenticationService: AuthenticationService
    ) { 
      this.subscription = router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          browserRefresh = !router.navigated; 
        }
    });
    this.bnIdle.startWatching(3 * 60 * 60).subscribe((res) => {
      const currentUser = this.authenticationService.currentUser();
      if (currentUser && res) {
        console.log(res);
        this.authenticationService.logout();
        this.router.navigate(['/account/login']);
      } 
    })
  }
}
